<template>
    <div
        class="modal-frame flex-center-hori"
        :class="{ active: modelValue }"
    >
        <transition name="bottom-page">
            <div
                class="frame-wrapper"
                v-if="modelValue"
            >
                <div
                    class="close-button"
                    @click="close"
                    v-if="showExit"
                ></div>
                <div class="frame">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'ModalBox',
    model: {
        prop: 'modelValue',
        event: 'change'
    },
    props: {
        modelValue: Boolean,
        showExit: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        close () {
            if (this.showExit) {
                this.$emit('change', false);
            }
        }
    }
};
</script>
<style scoped>
.modal-frame {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    background-color: var(--ai-model-wrapper-bg);
    opacity: 0;
    backdrop-filter: blur(0);
    transition: opacity 320ms, backdrop-filter 200ms;
    pointer-events: none;
}

.modal-frame.active {
    opacity: 1;
    backdrop-filter: blur(10px);
    pointer-events: auto;
}

.frame-wrapper {
    position: relative;
    display: flex;
    max-width: 100%;
    max-height: 100%;
    flex-flow: row;
    align-items: stretch;
}

.frame-wrapper>div {
    flex-grow: 1;
}

.frame {
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    background:  var(--ai-model-wrapper);
    box-shadow: var(--ai-model-wrapper-box-shadow);
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
}

.close-button {
    position: absolute;
    right: -40px;
    top: -2px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-image: var(--ai-model-close);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform-origin: center;
    transition: transform 180ms;
    transform: rotate(90deg) translateY(0);
    cursor: pointer;
    z-index: 129;
}

.active .close-button {
    transform: rotate(0deg) translateY(0);
}

.close-button:hover {
    transform: rotate(90deg) translateY(0);
}

.close-button:active {
    transform: rotate(90deg) translateX(2px);
    transition: transform 0s;
}

.bottom-page-enter-from,
.bottom-page-leave-to {
    translate: 0 18px;
    opacity: 0;
}

.bottom-page-leave-active {
    transition: 300ms ease-in;
}

.bottom-page-enter-active {
    transition: 270ms ease-out 120ms;
}

.bottom-page-enter-to,
.bottom-page-leave-from {
    translate: 0 0;
    opacity: 1;
}
</style>
